import React from 'react';
import BulkMessageForm from './form';
import { createBulkMessage } from '../../modules/Api';
import { normalizer } from './pipeline';
import { notification } from 'antd';
import history from '../../modules/History';

class AddBulkMessage extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});

        const formData = normalizer(values);
        createBulkMessage(formData, () => {
            notification.open({
                message: `پیامک انبوه با موفقیت ایجاد شد!`,
                description: `لطفا توجه داشته باشید که پیامک انبوه پس از ایجاد در صف ارسال قرار خواهد گرفت.`
            });
            this.setState({submitted: false});
            history.item.push(`/bulk-messages`);
        });
    }
    render() {
        return (<div><BulkMessageForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddBulkMessage;


// WEBPACK FOOTER //
// ./src/containers/BulkMessage/add.js